@if (componentData$ | async; as component) {
  <div class="container more-info" [style]="'background-color :'+ component.background">
    @if (component.title) {
      <div class="h2-component">{{component.title}}</div>
    }
    @if (items$ | async; as items) {
      <div class="items-info">
        @for (item of items; track item; let i = $index) {
          @if (item) {
            <app-custom-cms-item [item]="item | async"></app-custom-cms-item>
          }
        }
      </div>
    }
  </div>
}